import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { Heading } from '../../general'
import CollapsibleItem, {
  type ToggleCollapseFn
} from '../CollapsibleItem/CollapsibleItem'
import { ListItem } from '../ListItem'

interface MobileWrapperProps {
  title: string
}

const MobileWrapper = ({
  children,
  title
}: PropsWithChildren<MobileWrapperProps>) => {
  return (
    <Container
      header={(toggleCollapse: ToggleCollapseFn, collapsed: boolean) => (
        <FiltersHeader
          onClick={toggleCollapse}
          title={
            <FiltersTitle level={5} weight="bold">
              {title}
            </FiltersTitle>
          }
          toggleCollapse={toggleCollapse}
          isCollapsed={collapsed}
        />
      )}
    >
      <CollapsibleContent>{children}</CollapsibleContent>
    </Container>
  )
}

const Container = styled(CollapsibleItem)`
  display: none;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    display: block;
    border: 1px solid ${({ theme }) => theme.color.neutral.color7};
    border-radius: 16px;
    background-color: ${({ theme }) => theme.color.neutral.color10};
  }
`

const FiltersHeader = styled(ListItem)`
  padding: 12px 24px;
`
const FiltersTitle = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const CollapsibleContent = styled.div`
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export default MobileWrapper
